// @ts-nocheck
import { pipe } from './';
const SECOND = 1000;
const DEFAULT_DEBOUNCE_TIME = 2 * SECOND;
const DEFAULT_DEBOUNCE_TIMEOUT = 30 * SECOND;
const DEFAULT_MAX_BUFFER_SIZE = 5;
export const createPipe = funcs => pipe(...funcs.reverse())();
export const pipeDistribute = funcs => () => arg => funcs.forEach(func => func(arg));
export const pipeBufferDebounce = function (_temp) {
  let {
    debounceTime = DEFAULT_DEBOUNCE_TIME,
    timeout = DEFAULT_DEBOUNCE_TIMEOUT,
    maxBufferCount = DEFAULT_MAX_BUFFER_SIZE
  } = _temp === void 0 ? {} : _temp;
  return function (next) {
    let timer;
    let startTime = null;
    const values = [];
    const yieldOutput = function () {
      startTime = null;
      next(values.splice(0));
    };
    return value => {
      clearInterval(timer);
      values.push(value);
      startTime = startTime || Date.now();
      (values.length >= maxBufferCount ? yieldOutput : () => timer = setTimeout(yieldOutput, Math.max(Math.min(debounceTime, startTime + timeout - Date.now()))))();
    };
  };
};
//# sourceMappingURL=pipeline.js.map